import { css } from 'styled-components';
import { imageIcon } from '@sunbit-dev/purchase-common/src/theme/helpers';

const LogoContainer = css(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 43px;
    padding: 5px ${theme.spacing.large2}px 0;
    box-sizing: content-box;

    @media only screen and ${theme.device.laptopS} {
      height: 50px;
    }

    .logo-wrapper {
      > img {
        width: 100%;
        height: 100%;
        display: inline-block;
      }

      width: 99px;
      height: 30px;

      @media only screen and ${theme.device.laptopS} {
        width: 116px;
        height: 35px;
      }
    }
  `
);

export const Top = css(({ theme }) => {
  return css`
    width: 100%;
    z-index: 995;
    flex-shrink: 0;
    position: relative;

    @media only screen and ${theme.device.max.laptopS} {
      box-shadow: 3px 3px 7px 0 rgba(0, 0, 0, 0.16);
      background: ${theme.colors.white};
    }

    > .top-bar-container {
      min-height: 68px;
      background-color: ${theme.colors.white};
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 ${theme.spacing.large2}px;
      box-shadow: 3px 3px 7px 0 rgba(0, 0, 0, 0.16);

      @media only screen and ${theme.device.laptopS} {
        padding: 0 ${theme.spacing.huge}px;
      }

      @media only screen and ${theme.device.max.laptopS} {
        box-shadow: none;
      }

      > .logo-container {
        ${LogoContainer};
      }

      > .header-title {
        font-family: Poppins;
        font-size: 12px;
        line-height: 1;
        color: ${theme.colors.primaryBright};
        padding-bottom: 5px;
      }

      > .contact-support-button {
        position: absolute;
        right: 30px;
        filter: grayscale(1) brightness(1.25);
        cursor: pointer;

        &:focus {
          outline: none;
        }

        &:before {
          ${imageIcon({ icon: 'phone', height: 24, width: 24, color: theme.colors.primaryBright })};
        }
      }

      > .close-button {
        position: absolute;
        left: 30px;
        filter: grayscale(1) brightness(2.25);
        cursor: pointer;

        &:focus {
          outline: none;
        }

        &:before {
          ${imageIcon({ icon: 'close', height: 24, width: 24, color: theme.colors.disabledText })};
        }
      }
    }
  `;
});
